/*
  PYKAS CART DRAWER JS
  Zweck: (1) Live-Update des zweistufigen Schwellen-Balkens (Gratisversand → Gratis-Bucket)
         (2) Gift-Logik: Bucket-Produkt ab Gift-Schwelle automatisch als 0-€-Line-Item hinzufügen,
             unter der Schwelle entfernen (Property _pykas_gift markiert das Item)
         (3) Cross-Sell-ATC im Drawer ohne Reload.
  DOM-Hooks: [data-pykas-shipping-bar] (snippets/pykas-shipping-bar.liquid), cart-drawer (Dawn).
  Dokumentierte Alternative zur 0-€-Variante: Shopify Discount Function, die den Bucket bei
  Schwelle rabattiert — robuster, braucht App-Deployment. V1 = 0-€-Produkt.
  TODO: keine
*/

(function () {
  'use strict';

  var busy = false;

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function getBar() {
    return document.querySelector('[data-pykas-shipping-bar]');
  }

  function updateBar(cart) {
    var bar = getBar();
    if (!bar) return;
    var freeCents = parseInt(bar.dataset.freeCents, 10) || 0;
    var giftCents = parseInt(bar.dataset.giftCents, 10) || 0;
    if (freeCents <= 0) return;

    var giftLine = findGiftLine(cart);
    var total = cart.total_price - (giftLine ? giftLine.final_line_price : 0);
    var max = Math.max(freeCents, giftCents);
    // Ohne diese Wache ergibt max === 0 eine Division durch null -> Infinity,
    // Math.min(100, Infinity) === 100: der Balken stuende voll da, obwohl
    // nichts erreicht ist (Pauls Befund 20.08.).
    if (!(max > 0)) return;
    var percent = Math.round((total / max) * 100);
    if (!isFinite(percent) || percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    var erreicht = total >= freeCents;
    bar.classList.toggle('is-erreicht', erreicht);
    // Fortschritt ist seit dem Umbau 21.08. der Hintergrund der Schiene
    // SELBST (harter Verlauf) — kein Fuell-Div mehr, das ein Render-Pfad
    // verlieren koennte. Der dataset-Merker dient als Gleichheits-Wache:
    // style.background normalisiert der Browser (rgb statt hex), ein
    // Direktvergleich waere immer ungleich. Style- und data-Schreibzugriffe
    // sind Attribut-Mutationen — der childList-Observer in init() bleibt
    // davon unberuehrt.
    var track = bar.querySelector('[data-pykas-shipping-track]');
    if (track) {
      var farbe = erreicht ? '#008900' : '#1e3a44';
      var kante = percent > 0 ? 'max(' + percent + '%, 12px)' : '0%';
      var verlauf = 'linear-gradient(90deg, ' + farbe + ' ' + kante + ', #dcdedf 0)';
      if (track.dataset.pykasVerlauf !== verlauf) {
        track.dataset.pykasVerlauf = verlauf;
        track.style.background = verlauf;
      }
      if (track.getAttribute('aria-valuenow') !== String(percent)) {
        track.setAttribute('aria-valuenow', String(percent));
      }
    }

    var label = bar.querySelector('[data-pykas-shipping-label]');
    if (!label) return;
    var text;
    if (giftCents > 0 && total >= giftCents) {
      text = 'Bucket gesichert!';
    } else if (total >= freeCents) {
      text =
        giftCents > 0
          ? 'Gratisversand sicher — noch ' + formatMoney(giftCents - total) + ' bis zum Gratis-Bucket'
          : 'Gratisversand gesichert!';
    } else {
      text = 'Noch ' + formatMoney(freeCents - total) + ' bis Gratisversand';
    }
    if (label.textContent !== text) label.textContent = text;
  }

  function findGiftLine(cart) {
    return cart.items.find(function (item) {
      return item.properties && item.properties._pykas_gift === '1';
    });
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        }
      })
      .catch(function (error) {
        console.error('[pykas-cart-drawer] Drawer-Refresh fehlgeschlagen', error);
      });
  }

  function syncGift(cart) {
    var bar = getBar();
    if (!bar) return Promise.resolve(false);
    var giftCents = parseInt(bar.dataset.giftCents, 10) || 0;
    var giftVariantId = parseInt(bar.dataset.giftVariantId, 10) || 0;
    if (giftCents <= 0 || giftVariantId <= 0) return Promise.resolve(false);

    var giftLine = findGiftLine(cart);
    var total = cart.total_price - (giftLine ? giftLine.final_line_price : 0);

    if (total >= giftCents && !giftLine) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: giftVariantId, quantity: 1, properties: { _pykas_gift: '1' } }),
      }).then(function (response) {
        if (!response.ok) throw new Error('Gift-Add HTTP ' + response.status);
        return true;
      });
    }

    if (total < giftCents && giftLine) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 }),
      }).then(function (response) {
        if (!response.ok) throw new Error('Gift-Remove HTTP ' + response.status);
        return true;
      });
    }

    return Promise.resolve(false);
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        // Selbstheilung fuer Dawns Wurzel-Klasse: renderContents laesst is-empty
        // am <cart-drawer> stehen (nur .drawer__inner wird bereinigt), Dawns CSS
        // versteckt daran Kopf und Zeilen. Abgleich mit dem echten item_count;
        // Klassenwechsel ist eine Attribut-Mutation und triggert den
        // childList-Observer nicht.
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.toggle('is-empty', cart.item_count === 0);
        updateBar(cart);
        return syncGift(cart).then(function (changed) {
          if (changed) return refreshDrawer();
        });
      })
      .catch(function (error) {
        console.error('[pykas-cart-drawer] Cart-Check fehlgeschlagen', error);
      })
      .finally(function () {
        busy = false;
      });
  }

  function debounce(fn, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }

  function init() {
    var debouncedCheck = debounce(check, 400);

    document.addEventListener('pykas:cart-updated', debouncedCheck);

    // Dawn rendert den Drawer-Inhalt bei Mengenänderungen neu — MutationObserver fängt das ab
    var drawer = document.querySelector('cart-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(debouncedCheck).observe(drawer, { childList: true, subtree: true });
    }

    // Varianten-Dropdown der Cross-Sell-Karten (Pauls Auftrag 21.08.).
    // Delegation aus demselben Grund wie beim Formular darunter: Dawns
    // renderContents ersetzt das Drawer-Markup komplett, direkte Listener
    // waeren nach dem ersten Neuzeichnen weg.
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-pykas-cross-select]');
      if (!select) return;
      var option = select.options[select.selectedIndex];
      var card = select.closest('.pykas-cart-crosssell__card');
      if (!option || !card) return;
      var idInput = card.querySelector('input[name="id"]');
      if (idInput) idInput.value = option.value;
      var jetzt = card.querySelector('.pykas-preis__jetzt');
      if (jetzt && option.dataset.preis) jetzt.textContent = option.dataset.preis;
      var alt = card.querySelector('.pykas-compare-at');
      if (alt) {
        if (option.dataset.alt) {
          alt.textContent = option.dataset.alt;
          alt.hidden = false;
        } else {
          alt.hidden = true;
        }
      }
    });

    // Crosssell-Pfeile (Pauls Auftrag 21.08.): eine Karte je Ansicht, die
    // Pfeile blaettern den Snap-Viewport kartenweise. Delegation aus dem
    // gleichen Grund wie unten: renderContents ersetzt das Drawer-Markup.
    document.addEventListener('click', function (event) {
      var pfeil = event.target.closest('[data-pykas-cross-pfeil]');
      if (!pfeil) return;
      var block = pfeil.closest('.pykas-cart-crosssell');
      var viewport = block && block.querySelector('[data-pykas-cross-viewport]');
      if (!viewport) return;
      var richtung = parseInt(pfeil.dataset.pykasCrossPfeil, 10) || 1;
      viewport.scrollBy({ left: richtung * viewport.clientWidth, behavior: 'smooth' });
    });

    // Cross-Sell-Formulare im Drawer (event delegation, da der Drawer neu gerendert wird)
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-pykas-crosssell-form]');
      if (!form) return;
      event.preventDefault();
      var body = new FormData(form);
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      fetch(form.action + '.js', { method: 'POST', headers: { Accept: 'application/javascript' }, body: body })
        .then(function (response) {
          return response.json();
        })
        .then(function (parsedState) {
          var drawerEl = document.querySelector('cart-drawer');
          if (drawerEl && typeof drawerEl.renderContents === 'function') {
            // Add ⇒ Warenkorb nicht leer; Wurzel-Klasse ueberlebt renderContents
            // (siehe check()) und muss hier sofort weg, nicht erst beim Abgleich.
            drawerEl.classList.remove('is-empty');
            drawerEl.renderContents(parsedState);
          }
          debouncedCheck();
        })
        .catch(function (error) {
          console.error('[pykas-cart-drawer] Cross-Sell-ATC fehlgeschlagen', error);
          form.submit();
        });
    });

    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
